import * as storage from './storage';

export function getSnowplowId(): string | null {
	return storage.get('_sp_id');
}
